import type {ElementData} from '@Libraries/add-media-library';
import type {BasePanel} from '@Components/panel/panel.types';

export interface AiImagePanelProps extends BasePanel {
  className?: string;
  gridID?: string;
  selectionID?: string;
  populateRecentlyAddedOnItemAdd?: boolean;
  shouldLoadDataUrlImage?: boolean;
  mediaType?: MediaTypePrompt;
  onAddSelected(items: ElementData[]): void;
  onClose?(): void;
}

export enum AiImageModelOption {
  StabilityAICore = 1,
  StabilityAISDXL = 2,
  DeepInfraFluxSchnell = 3,
  StabilityAIUltra = 4,
  Auto = 5,
  Gemini2_5 = 6,
}

export enum TextToImageGridErrorState {
  NONE,
  GENERIC,
  FLAGGED,
  UNSUPPORTED_LANGUAGE,
  VAGUE,
}

export enum AiImageFilterOptions {
  Styles = 'styles',
  AspectRatio = 'aspect-ratio',
  AiModel = 'ai-model',
}

export enum AiImageStylesOptions {
  Photographic = 'photographic',
  DigitalArt = 'digital-art',
  Model3d = '3d-model',
  Cinematic = 'cinematic',
  ComicBook = 'comic-book',
  NeonPunk = 'neon-punk',
  LineArt = 'line-art',
  FantasyArt = 'fantasy-art',
  Anime = 'anime',
  PixelArt = 'pixel-art',
  AnalogFilm = 'analog-film',
}

export enum AiImageAspectRatioOptions {
  Square = 'SQUARE',
  LandScape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
}

export const enum MediaTypePrompt {
  PHOTO = 'photo',
  LOGO = 'logo',
  TEXT_ART = 'text-art',
  STICKER = 'sticker',
}

export const DEFAULT_SELECTED_AI_IMAGE_MODEL = AiImageModelOption.Auto;